import Cta from "@components/Cta/Cta";
import { GeneralLink } from "@customTypes/generalLink";
import slugify from "@utilities/slugify";
import clsx from "clsx";
import styles from "./GridCTAContainer.module.scss";

export type GridCtaBackgroundColour = "grey" | "blue";

export interface CtaContainerProps {
  title?: string;
  description?: string;
  ctaContent: {
    uid: string;
    fields: Partial<GeneralLink["fields"]>;
  }[];
  variation?: GridCtaBackgroundColour;
}

interface GridCtaLinkProps {
  ariaDescribedBy?: string;
  linkData: Partial<GeneralLink["fields"]>;
  isLight: boolean;
}

const GridCtaLink = ({
  ariaDescribedBy,
  linkData,
  isLight,
}: GridCtaLinkProps) => {
  return (
    <Cta
      linkText={linkData?.linkText || ""}
      url={linkData?.url || ""}
      contentReference={linkData?.contentReference}
      ariaDescribedBy={ariaDescribedBy}
      type="secondary"
      light={isLight}
    />
  );
};

export const GridCTAContainer = (props: { content: CtaContainerProps }) => {
  const { content } = props;
  const { ctaContent, description, variation = "grey", title } = content;

  const ariaDesribedBy = title ? `cta-container-${slugify(title)}` : undefined;
  const isLight = variation === "blue";

  return (
    <div className={clsx(styles["grid-cta-container"], styles[variation])}>
      <div className={clsx("wrapper", styles["grid-cta-container__section"])}>
        <div className={styles["grid-cta-container__wrapper"]}>
          <h3
            className={styles["grid-cta-container__heading"]}
            id={ariaDesribedBy}
          >
            {title}
          </h3>
          <p className={styles["grid-cta-container__description"]}>
            {description}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {(ctaContent ?? []).map((ctaItem, index) => (
            <GridCtaLink
              key={`${ctaItem.uid}-${index}`}
              ariaDescribedBy={ariaDesribedBy}
              linkData={ctaItem?.fields ?? {}}
              isLight={isLight}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GridCTAContainer;
